import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/Header';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { Link } from 'react-router-dom';
import DeleteAlert from '../../Common/Layout/DeleteAlert';
import Login from '../../Authentication/Login';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import HolidaySidebar from '../../Supplier/HolidaySidebar';

const CommentsViewModal = ({ show, onHide, comment }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Enquiry Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {comment ? (
                    <p className="text-muted fst-italic">"{comment}"</p>
                ) : (
                    <p className="text-muted">No comments were provided for this enquiry.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>Close</button>
            </Modal.Footer>
        </Modal>
    );
};



const DMCPackageEnquiry = () => {
    const { user, loading } = useAuth();
     const navigate = useNavigate(); 
    const [lists, setLists] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [data, setData] = useState([]);
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const handleOpenDeleteModal = (id) => {
        setItemToDelete(id);
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setItemToDelete(null);
    };
    const handleOpenCommentModal = (comment) => {
        setSelectedComment(comment);
        setShowCommentModal(true);
    };
    const handleCloseCommentModal = () => {
        setShowCommentModal(false);
        setSelectedComment(''); 
    };



    const GetData = async (pageNumber) => {
        const enquiryType = 'Holiday'; 
        const url = `${config.GETENQUIRYBYTYPE}/${user.cid}?type=${enquiryType}`;

        const res = await apiService.getAll(url, pageSize, pageNumber);
        console.log(res);
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setData(res.data);
        setTotalRecords(res.totalRecords);
    };
    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    const handleDelete = async () => {
        if (itemToDelete !== null) {
            try {
                await apiService.remove(config.DELETEPACKAGEENQUIRY, itemToDelete);
                await GetData(pageNumber); 
            } catch (error) {
                
            }
            handleCloseDeleteModal();
        }
    };

      useEffect(() => {
        if (!loading && !user) {
            navigate("/");
        }
    }, [user, loading, navigate]);

     useEffect(() => {
        if (user) { 
            GetData(pageNumber);
        }
    }, [user, pageNumber]); 

     if (loading) {
        return <p>Loading...</p>;
    }

    return (
            
            <div className="layout-wrapper">
                 
                   <Header user={user} />
                   <CommentsViewModal 
                show={showCommentModal}
                onHide={handleCloseCommentModal}
                comment={selectedComment}
            />
                       {/* WRAPPER TO ENABLE SIDEBAR LAYOUT */}
                       <div className="holidaydashboard-dashboard">
                           
                           {/* 1. SIDEBAR COMPONENT */}
                           <HolidaySidebar 
                               isOpen={sidebarOpen} 
                               onClose={() => setSidebarOpen(false)} 
                           />
           
                           {/* 2. MAIN CONTENT AREA */}
                           <main className="holidaydashboard-main-content">
                               
                               {/* Mobile Header for Sidebar Toggle */}
                               <div className="holidaydashboard-mobile-header">
                                   <button
                                       className="holidaydashboard-menu-toggle"
                                       onClick={() => setSidebarOpen(true)}
                                   >
                                       ☰
                                   </button>
                               </div>
           
                               {/* WRAP YOUR EXISTING FORM CONTENT */}
                               <div className="holidaydashboard-content-wrapper">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="table-responsive table-card p-2">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="bg-soft-success bg-gradient">
                                                {/* --- UPDATED --- Table headers for Enquiry data */}
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Customer Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Package Name</th>
                                                    <th>Destination</th>
                                                    <th>Enquiry Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {/* --- UPDATED --- Mapping over enquiry data */}
                                                {lists.length > 0 ? lists.map((v, index) =>
                                                    <tr key={v.packageEnquiryId}>
                                                        <td>{((pageNumber - 1) * pageSize) + index + 1}</td>
                                                        <td>{v.name}</td>
                                                        <td>{v.email}</td>
                                                        <td>{v.phoneNumber}</td>
                                                        <td>{v.packageName}</td>
                                                        <td>{v.
destinationName}</td>
                                                        <td>{moment(v.createdDate).format(
                                                            "DD-MMM-YYYY"
                                                        )}
                                                        </td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" title="View Comments">
                                                                    <Link className="view-item-btn" to="#" onClick={() => handleOpenCommentModal(v.comments)}>
                                                                        <i className="ri-message-2-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                    {/* --- UPDATED --- Using correct ID for delete */}
                                                                    <Link className="remove-item-btn" onClick={() => handleOpenDeleteModal(v.packageEnquiryId)}>
                                                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                                {/* You can add an "Edit" or "View" button here later if needed */}
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">No enquiries found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
                </main>
            </div>
        </div>
    );
};

export default DMCPackageEnquiry;